export default "__VITE_ASSET__f8TIwiCp__"